import { type FC } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useUnit } from 'effector-react';
import { $authInfo, $isAuthInitialized, getTokens, logoutSucceeded, setTokens } from '~/entities/auth';
import { routes } from '~/shared/constants/routes';
import { setTokenProvider, type TokenProvider } from '~/shared/api/token-provider';
import { AppLoader } from '../AppLoader';
import { AppShell, type AppShellProps, WatchersProvider } from './components';

type AppLayoutProps = AppShellProps;

const tokenProvider: TokenProvider = {
    getAccessToken: async () => {
        const { accessToken } = await getTokens();

        return accessToken;
    },
    updateAccessToken: async (accessToken) => {
        const tokens = await getTokens();

        await setTokens({ ...tokens, accessToken });
    },
    onUnauthorized: logoutSucceeded,
};

setTokenProvider(tokenProvider);

export const AppLayout: FC<AppLayoutProps> = (props) => {
    const { pathname } = useLocation();

    const isAuthRoute = pathname === routes.auth || pathname === routes.recover;

    const {
        0: { isAuthenticated },
        1: isAuthInitialized,
    } = useUnit([$authInfo, $isAuthInitialized]);

    if (!isAuthInitialized) {
        return <AppLoader />;
    }

    if (!isAuthenticated && !isAuthRoute) {
        return (
            <Navigate
                to={routes.auth}
                replace
            />
        );
    }

    return (
        <WatchersProvider>
            <AppShell {...props} />
        </WatchersProvider>
    );
};
